import { OrganizationEditor } from '@/components/OrganizationEditor';
import { OrganizationDangerZone } from '@/components/organization/OrganizationDangerZone';
import { OrganizationShareLinks } from '@/components/organization/OrganizationShareLinks';
import { useOrganization } from '@/hooks/useOrganizations';
import PageSkeleton from '@/layout/Skeleton';

export default function OrganizationSettings() {
  const organization = useOrganization();

  return (
    <PageSkeleton steps={[{ label: 'Organization Settings', href: '/settings' }]}>
      <div className='max-w-2xl mx-auto px-4 pt-6 w-full space-y-6'>
        <OrganizationEditor />
        <OrganizationShareLinks />
        {organization?.role === 'ADMIN' && <OrganizationDangerZone />}
      </div>
    </PageSkeleton>
  );
}
